import { render, staticRenderFns } from "./Osa001.vue?vue&type=template&id=0283faf1&scoped=true"
import script from "./Osa001.vue?vue&type=script&lang=js"
export * from "./Osa001.vue?vue&type=script&lang=js"
import style0 from "./Osa001.vue?vue&type=style&index=0&id=0283faf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283faf1",
  null
  
)

export default component.exports